import { default as fileHelper } from "@jmc/utils/utils/file-helper";
import type { CMSMaterialProps, CMSProductProps, CMSSpecialtyProps, MaterialEvent } from "@types";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import localizedFormat from "dayjs/plugin/localizedFormat";

dayjs.extend(localizedFormat);
dayjs.extend(isBetween);

const relatedProducts = (relatedTo: (CMSSpecialtyProps | CMSProductProps)[]): { item_product: string } | null => {
    if (!relatedTo.some((related) => (related as CMSProductProps).productTitle !== undefined)) return null;

    return {
        item_product: relatedTo
            .filter((related) => {
                return (related as CMSProductProps).productTitle !== undefined;
            })
            .map((r) => (r as CMSProductProps).productTitle)
            .join(", "),
    };
};

const relatedSpecialties = (relatedTo: (CMSSpecialtyProps | CMSProductProps)[]): { item_specialty: string } | null => {
    if (!relatedTo.some((related) => (related as CMSSpecialtyProps).specialtyTitle !== undefined)) return null;

    return {
        item_specialty: relatedTo
            .filter((related) => {
                return (related as CMSSpecialtyProps).specialtyTitle !== undefined;
            })
            .map((r) => (r as CMSSpecialtyProps).specialtyTitle)
            .join(", "),
    };
};

const mapMaterialImpression = (
    material: CMSMaterialProps,
    container: string,
    index: number | string = "unset",
    quantity = 0
): MaterialEvent => {
    const itemProduct = material?.related_to && relatedProducts(material?.related_to);
    const itemSpecialty = material?.related_to && relatedSpecialties(material?.related_to);

    return {
        item_name: material?.title,
        item_id: material?.id,
        item_price: "1.00",
        item_type: material?.type,
        item_targetaudience: material?.target_audience?.join("|"),
        item_file_name: material?.file_asset && fileHelper.getFileName(material?.file_asset.url),
        item_file_type: material?.file_asset && fileHelper.getFileType(material?.file_asset.url),
        item_list_name: container,
        item_list_position: index,
        quantity: quantity,
        ...(itemProduct && itemProduct),
        ...(itemSpecialty && itemSpecialty),
    };
};

export default {
    mapMaterialImpression,
};
